var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83066",
    "data-name": "Group 83066",
    transform: "translate(-494 -1943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23094",
    "data-name": "Path 23094",
    d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0",
    transform: "translate(494 1943)",
    fill: "#cdcdcd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23095",
    "data-name": "Path 23095",
    d: "M147.665,167.906c-.307-.41-9.949-13.144-10.079-13.316.111,0,1.381,0,1.511,0,.149.2,9.8,12.777,10.187,13.316Zm-2.309-8.007c1.1-1.273,5.547-6.453,6.037-7.04l-2.713-.017c-.736.848-4.336,4.887-4.662,5.245-.427-.538-4.036-5.007-4.23-5.266h-5.762c.709.916,6.75,8.784,7.014,9.129-1.468,1.683-6.108,7.014-6.647,7.64l2.992.037L142.4,163.9c.711.911,4.067,5.326,4.513,5.775.475,0,5.446-.035,5.741-.043-.626-.82-6.87-9.179-7.295-9.734",
    transform: "translate(369.975 1801.311)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social_twitter.e0b9e107cb92d793ecba723b6752d405.svg";
export { ForwardRef as ReactComponent };